var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('a',{staticClass:"btn",attrs:{"href":_vm.app_address_fixed,"target":"_blank"}},[_c('img',{attrs:{"src":_vm.$store.getters.getUrl('cp_anniu'),"alt":""}})])}
var staticRenderFns = []

export { render, staticRenderFns }